import {DashboardLayout} from 'components';
import {Constants} from 'helpers';
import React, {useRef} from 'react';
import {NavLink, useLocation, useParams} from 'react-router-dom';
import AccountOverviewReport from './AccountOverviewReport';
import Breadcrumbs from 'components/BreadCrumbs';
import {PAGES_URL} from 'helpers/constants';

const ROUTES = [
  {
    title: 'Customer Overview',
    to: Constants.PAGES_URL.FLOWS_ACCOUNTS_OVERVIEW,
    name: 'Customer Overview',
  },
  {
    title: 'Events',
    to: Constants.PAGES_URL.FLOWS_ACCOUNTS_EVENTS,
    name: 'Events',
  },
  {
    title: 'Cases',
    to: Constants.PAGES_URL.FLOWS_ACCOUNTS_CASES,
    name: 'Cases',
  },
];

function Routes({title, to, name, slug, account_id, state}) {
  const path = to?.replace(':slug', slug)?.replace(':id', account_id);
  return (
    <NavLink
      to={{pathname: path, state: {...state}}}
      state={{flowName: name}}
      className={({isActive}) =>
        `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
          isActive
            ? 'text-black bg-white shadow-tabs'
            : 'text-grey-500 bg-transparent'
        }`
      }
    >
      {title}
    </NavLink>
  );
}

function Layout({children, action}) {
  const {slug, id} = useParams();
  const {state} = useLocation();
  const reportRef = useRef(null);

  const flowName = state?.flowName || localStorage.getItem('flowName') || '';

  const currentAccount = JSON.parse(
    localStorage.getItem('currentAccount') || '{}',
  );

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Fraud Flows</p>
      }
      action={action}
    >
      <div className="flex items-center min-h-[52px] py-2 flex-wrap gap-3 justify-between mr-[-24px] ml-[-32px] px-8 border border-transparent border-b-[#E4E3E6]">
        <Breadcrumbs
          items={[
            {label: 'Fraud Flows', path: PAGES_URL.FLOWS},
            {label: flowName, path: `/flows/accounts/${slug}`},
            {label: 'Account Details'},
          ]}
        />
      </div>

      <div style={{position: 'absolute', left: '-9999px', top: '-9999px'}}>
        <AccountOverviewReport ref={reportRef} accountData={''} />
      </div>

      <div className="flex items-center flex-wrap justify-between gap-6 mt-4 mb-6 md:gap-0">
        <h2 className="md:text-base text-sm font-medium text-grey">
          Account Name:{' '}
          <span className="text-[#5C688E]">
            {currentAccount?.user_name || ''}
          </span>
        </h2>

        <div className="flex items-center gap-4 flex-wrap">
          {/* <FilterButton /> */}
          {/* <PrimaryButton
            buttonText="Download Report"
            xPadding="px-4"
            onClick={handleDownloadReport}
          /> */}
        </div>
      </div>
      <div className="rounded-md mt-4 bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
        {ROUTES.map((route, index) => (
          <Routes
            key={index}
            {...route}
            slug={slug}
            account_id={state?.id || id}
            state={state}
          />
        ))}
      </div>
      {children}
    </DashboardLayout>
  );
}

export default Layout;
